export const USERTEST_DOC_KEY = 'usertest';
export const RESPONSE_DOC_KEY = 'userTestResponse';
